import { render, staticRenderFns } from "./Exports.vue?vue&type=template&id=f135175e&scoped=true"
import script from "./Exports.vue?vue&type=script&lang=ts"
export * from "./Exports.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f135175e",
  null
  
)

export default component.exports